<template>
  <div class="upper-subpanel--inside">
    <slot>
      <h3>請掃描{{ barcodeTitle }}條碼</h3>
    </slot>
    <img class="med-pack" v-if="this.barcodeTitle === '藥單條碼'" 
      src="/static/img/med_pack.jpg"
      alt="">
  </div>
</template>

<script>
export default {
  name: 'ScanBarcode',
  data() {
    return {
      // barcodeRaw: '',
    };
  },
  computed: {
    currentApp() {
      return this.$store.state.currentApp.name;
    },
    barcodeTitle() {
      if (this.currentApp === '新增藥物') return '欲新增藥盒';
      if (this.currentApp === '一般取藥') return '藥單條碼';
      if (this.currentApp === '一般退藥') return '藥單條碼';
      if (this.currentApp === '醫囑退藥') return ' AUTOIX 二維';
      return '';
    },
  },
  mounted() {
    let pressed = false;
    let chars = [];
    window.addEventListener('keypress',
    (e) => {
      // console.log(e.which, String.fromCharCode(e.which));
      if (e.which > 13) {
        chars.push(String.fromCharCode(e.which));
      }

      if (pressed === false) {
        setTimeout(() => {
          if (chars.length >= 10) {
            const barcode = chars.join('');
            this.$emit('setBarcode', barcode);
          }
          chars = [];
          pressed = false;
        }, 500);
      }
      pressed = true;
    });
  },
  // methods: {
  //   cgmhBarcode(val) {
  //     // 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)

  //   },
  // },
};
</script>

<style lang="sass">
.med-pack
  height: 90%;
  margin-left: 10%;
</style>






// WEBPACK FOOTER //
// ScanBarcode.vue?963bfc4c